import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router,ActivatedRoute  } from "@angular/router";
import { Location } from '@angular/common';
//import { UserRoleCount } from 'src/app/Model/Authentication/RoleCount/user-role-count.model'

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  searchText;
allUsers=[];
modalUser:any=[];
  perms=true;
  branchCount=[];
  mississuagaCount;
  lawrenceCount;
  vaughanCount;
  torontoCount;
  teamleadCount;
  techsupportCount;
  administratorCount;
  systemadministratorCount;
  success;
  error;

  allUsersWithColors: any[] = [];

  constructor(private _authenticationService: AuthenticationService,
    private modalService: NgbModal,
    private router: Router, 
    private _location: Location,
    private actroute: ActivatedRoute) { }

  ngOnInit() {
    this.getAllBranchCount();
this.loadAllUsers();



  }//End of ngOnInit




  /**loadAllUsers(){
    this._authenticationService.getAllUsers().subscribe(
      (res)=>this.allUsers = (res),
      
    // this.assets=<AssetFormModel[]> response.assets;
    
      (err) => console.log(err)
    );
  }**/

    loadAllUsers(){

      this._authenticationService.getAllUsers().subscribe(
        res=> {
          
          this.allUsers = res;
          this.processUsersWithRandomColors(); 
          
        } ,
  
          
  
      // this.assets=<AssetFormModel[]> response.assets;
      
        (err) => console.log(err)
      );

this.processUsersWithRandomColors();
console.log(this.allUsersWithColors)
  }


  backClicked() {
    this._location.back();
    }
    

  refreshWindow(){
    location.reload();
  }

  actionDelete(users){
    console.log(users);
    this._authenticationService.deleteUserByID(users)
    .subscribe(//subscribe to Observable
      response => {
        console.log('Success!', response);

        this.modalService.dismissAll();
       
        document.getElementById("openSuccessModalButton").click();

      },

      error => {
        console.error('Error!', error);
        this.error = error.error.text;
        this.modalService.dismissAll();
        document.getElementById("openErrorModalButton").click();
        
      }
    );
  }

  

  passDetailToModal(users){
    this.modalUser=null;
    console.log(users);
    this.modalUser=Object.assign(users);
    console.log(this.modalUser);
  }

  viewUser(users){
    console.log(users);
    this.router.navigate(['../individual-user-fullview',{extra:users.userName, extra1:users.role, extra2:users.branch, extra3:users.email}],{relativeTo:this.actroute});
  }

  editUser(user){
    console.log(user.pid);
      this.router.navigate(['../user-edit', { extra: user.pid, extra1: user.userName }], { relativeTo: this.actroute });
  }

  getAllBranchCount(){
    this._authenticationService.getAllBranchCount().subscribe(
      (res) => {

        this.branchCount = res[0];
console.log(this.branchCount);
     this.mississuagaCount=this.branchCount['mississuaga'];
  /**   this.administratorCount=this.accessCount['administrator'];
     this.systemadministratorCount=this.accessCount['systemadministrator'];
     this.teamleadCount=this.accessCount['teamlead'];
     this.techsupportCount=this.accessCount['techsupport'];**/
     this.torontoCount=this.branchCount['toronto'];
     this.lawrenceCount=this.branchCount['lawrence'];
     this.vaughanCount=this.branchCount['vaughan'];
     
      },
      (err) => {
        this.error = err;
      }
    );
  }




// Add random colors to each user in allUsers
processUsersWithRandomColors() {
  this.allUsersWithColors = this.allUsers.map(user => ({
    ...user,
    
    initialsColor: this.getRandomLightColor()  // Add random color
  }));
}

// Function to get initials
getInitials(user: any): string {
  const firstNameInitial = user.firstName ? user.firstName[0] : '';
  const lastNameInitial = user.lastName ? user.lastName[0] : '';
  return firstNameInitial + lastNameInitial;

}


// Method to generate a random light color
getRandomLightColor(): string {
    const letters = 'BCDEF'; // Light colors use high values
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * letters.length)];
    }
    return color;
}


}



